<template>
  <v-menu
    v-model="menuOptions.showMenu"
    :position-x="menuOptions.x"
    :position-y="menuOptions.y"
    min-width="44.5%"
    offset-y
    absolute
    bottom
    :close-on-content-click="false"
    :close-on-click="false"
  >
    <v-list>
      <v-list-item>
        <div class="d-flex align-center" :class="`justify-${justifyStyle}`" style="width: 100%">
          <span v-if="isInEditorMode">{{ $t('dr-button.menuContent') }}</span>
          <v-btn icon @click="closeModelerExtendedMenu">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-list-item>
      <v-list-item>
        <dr-simple-layout
          :model="model.OnClickAction.PopUpExtendedModel[0]"
          :parentsWidgets="parentsWidgets"
          :readonly="false"
          style="width: 100%"
          @modelChanged="changePopUpWidgetsModel"
        />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import en from '../../langs/dr-button/en.json'
  import ru from '../../langs/dr-button/ru.json'
  import uk from '../../langs/dr-button/uk.json'
  import inputMixin from '../../mixins/input-mixin'
  import baseMixin from '../../mixins/base-mixin'
  import actionMixin from '../../mixins/actions-mixin'
  import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
  export default {
    props: ['menuOptions'],
    mixins: [baseMixin, inputMixin, actionMixin, widgetsWrapperMixin],
    data: () => ({
      menu: false
    }),
    computed: {
      // Кнопку закрыть меню в режиме проигрования, показывать в правом углу
      // Если в режиме редактирования, делаем space-between для спана и кнопки закрия
      justifyStyle() {
        if (this.isInEditorMode) {
          return 'space-between'
        }

        return 'end'
      }
    },
    methods: {
      changePopUpWidgetsModel(value) {
        this.$emit('change-popup-widgets-model', value)
      },
      closeModelerExtendedMenu() {
        this.$emit('close-modeler-extended-menu')
      }
    },
    i18n: {
      messages: {
        uk,
        en,
        ru
      }
    }
  }
</script>
